// extracted by mini-css-extract-plugin
export default {"card_title_container":"card-title_card_title_container__XDK0z","trapezoid_card_title":"card-title_trapezoid_card_title__DdClE"};